/*
 * 功能名称: 历史工作成果统计
 * 创 建 人: 张敬磊
 * 日    期: 2025年9月4日
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class WorkDeliveryStaticsAPi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-delivery-statics'
  }
}